export const handleTabClick = (serviceId, dispatch, setCurrentService, currentService) => {
    if (currentService === serviceId) {
        dispatch(setCurrentService(0));
    } else {
        dispatch(setCurrentService(serviceId));
    }
};
